// extracted by mini-css-extract-plugin
export default {"header":"Header_header__myc7i","solo_logo":"Header_solo_logo__PfCCd"};